import { useEffect } from "react";
import "../styles/main.css"
import "../styles/Home.css"
import esnLogo from './images/pt-lisboa-logo-colour.png';




function PageLayout(props) {
  useEffect(() => {

    // check footer height to add padding automatically
    document.getElementById('footer-oscar');

  }, []);

  return (
    <div >
      <div className="home-page">

      {props.children}
      <img src={esnLogo} alt="ESN Lisboa" className="esn-logo"></img>
      </div>


    </div>

  );
}

export default PageLayout;
